import { WEB_FLIGHTS_LVE_DEAL_LANDING_PAGE } from "@flights/constants";
import { createTrackingUtils } from "../index.js";
const utils = createTrackingUtils({
    name: WEB_FLIGHTS_LVE_DEAL_LANDING_PAGE,
    defaultStage: 1,
    stages: {
        main: 1,
        desktop_home: 2,
        mdot_home: 3,
        logged_out_home: 4,
        logged_in_home: 5,
        logged_in_banner_visible: 6,
        desktop_logged_in_banner_visible: 7,
        mdot_logged_in_banner_visible: 8,
        deals_page: 9
    },
    goals: {
        entry_clicked: 1,
        popular_offer_clicked: 2,
        airline_offer_clicked: 3,
        highlighted_offer_clicked_sr: 4,
        expand_list_clicked: 5
    },
    goalsWithValue: []
});
export default utils;
